<template lang="pug">
  .post-header
    post-user-icon(:icon="post.author_logo" :href="post.uri")
    .post-header__user-name
      a.post-header__link(:href="post.uri" target="_blank") {{ post.author }}
      .post-header__date {{ postTime }}
    post-counters(:post="post")
    .post__print(@click="printPostAction")
      img(
        src="../../assets/images/icon-printer.svg"
      )
</template>

<script>
import PostCounters from '@/components/posts/postCounters.vue';
import PostUserIcon from '@/components/posts/postUserIcon.vue';

export default {
  name: 'postHeader',
  components: { PostUserIcon, PostCounters },
  props: {
    post: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      postTime: '',
    };
  },
  methods: {
    printPostAction() {
      this.$emit('printPostAction');
    },
    updateTime() {
      this.postTime = this.$moment(this.post.created_date).fromNow()
    }
  },
  mounted() {
    this.updateTime();
    setInterval(() => {
      this.updateTime();
    }, 60000);
  }
};
</script>

<style lang="stylus">
.post
  width 100%
  &__print
    flex-shrink 0
    @media screen and (max-width 450px)
      display none
  &-header
    @media screen and (max-width 450px)
      flex-wrap wrap
    &__user-name
      margin 0 1em
      color #460303
      @media screen and (max-width 450px)
        max-width calc(100% - 6em)
    &__link
      display block
      text-decoration none
      color inherit
      &:hover
        text-decoration underline
    &__date
      margin-top .3em
      opacity .6
      display block
      color #460303
      text-decoration none
    &__counters
      display flex
      align-items center
      margin-left auto
      @media screen and (max-width 450px)
        width 100%
        justify-content flex-start
        margin-left 4.7em
        margin-top -.4em
  &-counter
    display flex
    &__icon
      margin-left .8em
      width 1em
      height 1em
    &__count
      margin-left .3em
</style>
